import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Wrapper } from "@cinch-nx/shared-ui";
import { supportContactContent } from "../../data/content";
import SupportAddress from "../address/support-address";
import Complaints from "../complaints/complaints";
import ContactCard from "../contact-card/contact-card";
import SupportFaqs from "../faqs/support-faqs";
import SupportPreFooter from "../pre-footer/support-pre-footer";
import styles from "./help-and-support.module.css";
export const callUsPhoneNumberDigits = (str)=>str.replace(/\D/g, "");
const HelpAndSupport = ({ faqs  })=>{
    const { whatsAppHeading , whatsAppHref , smsHref , whatsAppBody , whatsAppCta , textHeading , textBody , textCta , emailHeading , emailBody , emailCta , emailHref , callHeading , callBody , callCta  } = supportContactContent;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: styles.title,
                        children: "Help and support"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.panels,
                        children: [
                            /*#__PURE__*/ _jsx(ContactCard, {
                                svgType: "whatsapp",
                                heading: whatsAppHeading,
                                body: whatsAppBody,
                                cta: whatsAppCta,
                                category: "whatsApp",
                                href: whatsAppHref,
                                shouldHideOnDesktop: true
                            }),
                            /*#__PURE__*/ _jsx(ContactCard, {
                                svgType: "smartphone",
                                heading: textHeading,
                                body: textBody,
                                cta: textCta,
                                href: smsHref,
                                category: "text",
                                shouldHideOnDesktop: true
                            }),
                            /*#__PURE__*/ _jsx(ContactCard, {
                                svgType: "mail",
                                heading: emailHeading,
                                body: emailBody,
                                cta: emailCta,
                                href: emailHref,
                                category: "email"
                            }),
                            /*#__PURE__*/ _jsx(ContactCard, {
                                svgType: "phone",
                                heading: callHeading,
                                body: callBody,
                                cta: callUsPhoneNumberDigits(callCta),
                                href: `tel:${callCta}`,
                                category: "phone"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Complaints, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.faqWrapper,
                        children: /*#__PURE__*/ _jsx(SupportFaqs, {
                            faqs: faqs
                        })
                    }),
                    /*#__PURE__*/ _jsx(SupportAddress, {})
                ]
            }),
            /*#__PURE__*/ _jsx(SupportPreFooter, {})
        ]
    });
};
export default HelpAndSupport;
